import { GiftCardsUtilService } from './ib-gift-cards-utils.service';
import * as angular from 'angular';
export class LanguageAndMarketService {

    constructor (private $cookies: angular.cookies.ICookiesService, private $window: ng.IWindowService & { 'navigator': { browserLanguage: any } }, private GiftCardsAppConstants: GiftCardsAppConstant, private GiftCardsUtilService: GiftCardsUtilService, private tmhDynamicLocale: any) {

    }

    ////////////////
    init = ()=> {
        /////////////LANGUAGE AND MARKET///////////
        const langCookie = this.$cookies.get(this.GiftCardsAppConstants.COOKIES.PERSONALIZATION);
        const langUrl = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.lang);
        const langUrlMarket = this.GiftCardsUtilService.getParameterByName(this.GiftCardsAppConstants.nameParameters.market);
        let langNav = this.$window.navigator.language || this.$window.navigator.browserLanguage;
        let lang = '';
        let market = '';
        langNav = langNav && langNav.split('-')[0];

        //The first criterion to define the language is by parameter in the URL
        if (angular.isDefined(langUrl) && langUrl !== null) {
            lang = langUrl.toLowerCase();
        } else if (angular.isDefined(langCookie)) {
            lang = langCookie.split('|')[2];
        } else if (angular.isDefined(langNav)) {
            lang = langNav.toLowerCase();
        } else {
            lang = this.GiftCardsAppConstants.defaultLang;
        }

        //The first criterion to define the market is by parameter in the URL
        if ( angular.isDefined(langUrlMarket) && langUrlMarket !== null ) {
            market = langUrlMarket.toUpperCase();
        } else if (angular.isDefined(langCookie) ) {
            market = langCookie.split('|')[1];
        } else {
            market = this.GiftCardsAppConstants.defaultMarket;
        }

        if (this.GiftCardsAppConstants.availableLanguages.indexOf(lang) === -1) {
            lang = this.GiftCardsAppConstants.defaultLang;
        }

        //update the cookie with the new values of market and language
        const content = market + '|' + market + '|' + lang + '| | |' + market + '|';
        const expiration = new Date();
        expiration.setTime(expiration.getTime() + this.GiftCardsAppConstants.COOKIES.DEFAULT_EXPIRY_TIME);
        this.$cookies.put(this.GiftCardsAppConstants.COOKIES.PERSONALIZATION, content, { expires: expiration, path: this.GiftCardsAppConstants.COOKIES.DEFAULT_PATH });
        this.GiftCardsAppConstants.market = market;
        this.GiftCardsAppConstants.lang = lang;
        this.tmhDynamicLocale.set(lang);
    };
}
LanguageAndMarketService.$inject = ['$cookies', '$window', 'GiftCardsAppConstants', 'GiftCardsUtilService', 'tmhDynamicLocale'];
try {
    const mod = angular.module('ib-gift-cards-service-module');
    mod.service(
        'LanguageAndMarketService',
        LanguageAndMarketService
    );
} catch (error) {
    const mod = angular.module('ib-gift-cards-service-module', []);
    mod.service(
        'LanguageAndMarketService',
        LanguageAndMarketService
    );
}
